var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomeprofilelight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 29.6397,
    fill: "white",
    stroke: "#E3E8EA",
    strokeWidth: 1.27941
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16998_174325)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.35 23.75C35.35 26.1524 37.2975 28.1 39.7 28.1C42.1024 28.1 44.0499 26.1524 44.0499 23.75C44.0499 21.3476 42.1024 19.4 39.7 19.4C37.2975 19.4 35.35 21.3476 35.35 23.75ZM27.2153 29.7784C26.9594 29.463 26.5491 29.4608 26.2946 29.7675L26.2939 29.7668L16.6253 41.3697C16.3744 41.6698 16.4853 41.9236 16.8819 41.9236H45.1047C45.4998 41.9236 45.6274 41.6633 45.386 41.3414L39.9043 34.0319C39.6643 33.7122 39.2532 33.6948 38.9886 33.9979L35.1374 38.4073C34.8713 38.7111 34.453 38.7009 34.1993 38.3892L27.2153 29.7784Z",
    fill: "#E3E8EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16998_174325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.5,
    height: 43.5,
    fill: "white",
    transform: "translate(9.25 9.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomeprofilelight);
export default __webpack_public_path__ + "static/media/customeprofilelight.6169ebdb08432da97af495949354968e.svg";
export { ForwardRef as ReactComponent };